/* eslint-disable no-unused-vars */

export enum ActionItemType {
  TEXT_NOTE = 'TEXT_NOTE',
  WORK_ITEM = 'WORK_ITEM',
  MONDAY_ITEM = 'MONDAY_ITEM',
}

(window as { ActionItemType? }).ActionItemType = ActionItemType;
